/* istanbul ignore file */
import React from 'react';
import { LinkButton } from 'framework/ui/ui-builder';

const EditEmailButton = ({
  path,
  isVisible = true,
  ...props
}: {
  isVisible?: boolean;
  path: string;
  [key: string]: any;
}) => {
  return isVisible ? (
    <LinkButton variant="outlined" url={path} {...props}>
      Edit
    </LinkButton>
  ) : (
    <></>
  );
};

export default EditEmailButton;
